import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCachedTexts } from '../hooks/useCachedTexts';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const { getText } = useCachedTexts('footer');

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* Logo and Tagline */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src={`${process.env.PUBLIC_URL}/svg/w_magicomms-logo-letters.svg`} alt="Magicomms" />
            </Link>
            <p className="footer-tagline">PR, Media Relations & Digital Content</p>
          </div>

          {/* Navigation Links */}
          <div className="footer-links">
            <div className="footer-column">
              <h4>{getText('company_heading', t('footer.company'))}</h4>
              <ul>
                <li><Link to="/about" onClick={() => window.scrollTo(0, 0)}>{getText('link_about', t('nav.about'))}</Link></li>
                <li><Link to="/about#services">{getText('link_services', t('nav.services'))}</Link></li>
                <li><Link to="/team" onClick={() => window.scrollTo(0, 0)}>{getText('link_team', t('nav.team'))}</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>{getText('work_heading', t('footer.work'))}</h4>
              <ul>
                <li><Link to="/portfolio" onClick={() => window.scrollTo(0, 0)}>{getText('link_portfolio', t('nav.portfolio'))}</Link></li>
                <li><Link to="/news" onClick={() => window.scrollTo(0, 0)}>{getText('link_news', t('nav.news'))}</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>{getText('contact_heading', t('footer.connect'))}</h4>
              <ul>
                <li><a href="https://www.instagram.com/magicomms" target="_blank" rel="noopener noreferrer">{getText('link_instagram', 'Instagram')}</a></li>
                <li><a href="https://www.linkedin.com/company/magicomms" target="_blank" rel="noopener noreferrer">{getText('link_linkedin', 'LinkedIn')}</a></li>
                <li><a href="mailto:pr@magicomms.com">{getText('link_email', 'Email')}</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            {getText('copyright', `© ${currentYear} Magicomms. ${t('footer.rights')}`)}
          </p>
          <a 
            href="https://www.hellomar.co" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-credit"
          >
            Made by Marco
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
